import { MgSupplierItemMinimalDTO } from '../../dto';
import { DiscountGroup } from '../DiscountGroup';
import { MgSupplierMinimal, ProductGroupMinimal } from '../price';

export interface MgSupplierItemMinimalProps {
  primaryText?: string;
  secondaryText?: string;
  mgItemNumber: number;
  finfoNumber?: number;
  mgSupplierItemId?: number;
  productGroup: ProductGroupMinimal;
  discountGroup?: DiscountGroup;
  mgParticipantAccount: MgSupplierMinimal;
}

export class MgSupplierItemMinimal {
  primaryText?: string;
  secondaryText?: string;
  mgItemNumber: number;
  finfoNumber?: number;
  mgSupplierItemId?: number;
  productGroup: ProductGroupMinimal;
  discountGroup?: DiscountGroup;
  mgParticipantAccount: MgSupplierMinimal;

  constructor({
    primaryText,
    secondaryText,
    mgItemNumber,
    finfoNumber,
    mgSupplierItemId,
    productGroup,
    discountGroup,
    mgParticipantAccount,
  }: MgSupplierItemMinimalProps) {
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.mgSupplierItemId = mgSupplierItemId;
    this.productGroup = productGroup;
    this.discountGroup = discountGroup;
    this.mgParticipantAccount = mgParticipantAccount;
  }

  static fromDto = ({
    primaryText,
    secondaryText,
    mgItemNumber,
    finfoNumber,
    mgSupplierItemId,
    productGroup,
    discountGroup,
    mgParticipantAccount,
  }: MgSupplierItemMinimalDTO): MgSupplierItemMinimal => {
    return new MgSupplierItemMinimal({
      primaryText,
      secondaryText,
      mgItemNumber,
      finfoNumber,
      mgSupplierItemId,
      productGroup,
      discountGroup,
      mgParticipantAccount,
    });
  };
}
